import React from 'react'

import { type ComparisonBrand } from '../../hooks/useNpiDriverTableData'

import styles from './ComparisonAdvantageBrandsCell.css'

export type ComparisonAdvantageBrandsCellProps = {
  brands: ComparisonBrand[]
}

// 比較優位対象ブランド: 自社が有意に優位だった競合ブランド名のタグ一覧
export const ComparisonAdvantageBrandsCell = ({
  brands,
}: ComparisonAdvantageBrandsCellProps) => {
  if (brands.length === 0) {
    return null
  }

  return (
    <div className={styles.brandTags}>
      {brands.map((brand) => (
        <span key={brand.id} className={styles.brandTag}>
          {brand.name}
        </span>
      ))}
    </div>
  )
}
